import {RequestFieldList} from "./request_field_list";

export class RequestField {
  order?: number
  value?: string
  readOnly?: boolean
  hidden?: boolean
  valid?: boolean
  possibleValues?: Record<string, string>
  mapping?: string
  externalMapping?: string
  label?: string
  component?: string
  min?: number
  max?: number
  active?: boolean
  placeholder?: string
  hideRelatedFields?: Record<string, object>
  secure?: boolean
  optional?: boolean

  private readonly _name: string;
  private readonly _owner: RequestFieldList;

  constructor(owner: RequestFieldList, name: string) {
    this._name = name;
    this._owner = owner;

    return new Proxy(this, {
        set(target, prop, value, receiver) {
          const propStr = prop.toString();
          // Check if it's a public property (doesn't start with underscore)
          if (!propStr.startsWith('_') && propStr in target) {
            // Call propagate on the owner if it exists
            if (target._owner && typeof target._owner.propagate === 'function') {
              target._owner.propagate(target._name, propStr, value);
            }
          }

          return Reflect.set(target, prop, value, receiver);
        }
      }
    )
  }

  toJSON(): any {
    return {
      [this._name]: this.calculatedValue()
    }
  }

  calculatedValue(): object {
    const result: any = {};

    for (const key in this) {
      if (this.hasOwnProperty(key)  // find properties
        && !key.startsWith('_') // remove private ones by naming convention
        && this[key] !== undefined) { // ignore undefined ones
        result[key] = this[key];
      }
    }

    return result;
  }
}
